import { getLabelPrintedStatus } from '../../../store/bulk/print/bulk.print.actions';

export const GetLabelPrintedStatusStep = (state, jobId) => {
  return [getLabelPrintedStatus(jobId)];
};
